module.exports = __webpack_public_path__ + "img/chest.fbe4a933.png";